/* eslint-disable */


/**
 * Create styles for `<OrderPage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderPage />` styles
 */
const orderConcreteDeliveriesPageStyles = ({ theme }) => ({
  container: {
    height: `100%`,
  },
});

export default orderConcreteDeliveriesPageStyles;
